import { styled } from 'goober';

import type { ContentItemCategory } from '@/api/v4/content-items.api';
import { Spotlight } from '@/features/spotlight/spotlight';
import { Flexbox } from '@/ui/flexbox/flexbox';

import { FeedBoard } from './feed-board';
import { FeedTabHeader } from './feed-tab-header';
import type { FeedTab } from './feed.state';

export const FeedTabContent = ({ tab }: { tab: FeedTab }) => {
  const getBoardContent = (tab: FeedTab) => {
    switch (tab) {
      case 'businessOpportunity':
      case 'materials':
      case 'trends':
        return <FeedBoard category={tab as ContentItemCategory} />;
      default:
        return <FeedBoard />;
    }
  };

  return (
    <Container direction="column">
      {tab !== 'spotlight' && <FeedTabHeader tab={tab} />}
      <BoardContainer direction="column">
        {tab === 'spotlight' ? <Spotlight /> : getBoardContent(tab)}
      </BoardContainer>
    </Container>
  );
};

const Container = styled(Flexbox)`
  flex: 1;
  min-height: 0;
  padding: 32px 40px 60px;
  overflow-y: auto;
`;

const BoardContainer = styled(Flexbox)`
  flex: 1;
  min-height: 0;
`;
